export const formContent = [
  {
    id: 1,
    text: $t('客户'),
    type: 'select',
    paramsName: 'sceneId',
    isChooze: false,
    selectParam: []
  },
  {
    id: 2,
    text: $t('时间'),
    type: 'datetimerange',
    paramsName: 'time',
    isChooze: false
  }
]
